<template>
    <div class="font-weight-thin caption text-center">
        Made with
        <v-icon x-small style="color:#ff3460;">fa-heart</v-icon>
        by <a style="font-weight: 500;" href="http://www.dynameat.io/">DynamEat</a>
        &copy; {{current_year}}
    </div>

</template>

<script>
export default {
  name: 'MadeWithLove',
  data() {
    return {
      current_year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>

</style>
